import cx from "classnames";

import { Icon } from "common/ui/Icon";
import { Caption } from "common/ui/Caption";

import styles from "./ErrorDisplay.module.scss";

interface Props {
  error: string;
  className?: string;
}

export function ErrorDisplay({ error, className }: Props) {
  return (
    <div className={cx(styles.ErrorDisplay, className)}>
      <Icon icon="alertMinor" />
      <Caption>{error}</Caption>
    </div>
  )
}
